import React, { useState } from "react";
import { Button } from "@lightspeed/flame/Button";
import { FaInfoCircle } from "react-icons/fa";

const OverShortInfo = () => {
  const [open, setOpen] = useState(false);

  const openModal = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setOpen(true);
  };

  return (
    <>
      <span
        role="button"
        tabIndex={0}
        aria-label="Over Short Description info"
        onClick={openModal}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") openModal(event);
        }}
        style={{ display: "inline-block", marginLeft: 4, verticalAlign: "middle", cursor: "pointer" }}
      >
        <FaInfoCircle />
      </span>

      {open && (
        <div
          onClick={() => setOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15, 23, 42, 0.45)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 24,
          }}
        >
          <div
            onClick={(event) => event.stopPropagation()}
            style={{
              width: "100%",
              maxWidth: 640,
              background: "#fff",
              borderRadius: 16,
              boxShadow: "0 24px 80px rgba(0,0,0,0.25)",
              overflow: "hidden",
              textAlign: "left",
            }}
          >
            <div
              style={{
                padding: "16px 20px",
                borderBottom: "1px solid #e2e8f0",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div style={{ fontSize: 18, fontWeight: 700, color: "#0f172a" }}>
                Over / Short Description
              </div>
              <button
                type="button"
                onClick={() => setOpen(false)}
                style={{ border: "none", background: "transparent", fontSize: 20, cursor: "pointer", color: "#64748b" }}
              >
                &times;
              </button>
            </div>

            <div style={{ padding: 20, color: "#1e293b", lineHeight: 1.6, fontSize: 14 }}>
              <p style={{ margin: "0 0 12px" }}>
                Used for mapping cash drawer Over / Short amounts recorded during POS cash
                closing and reconciliation.
              </p>
              <p style={{ margin: "0 0 12px" }}>
                If this mapping is configured, the counted amount differences will be included
                and displayed in the report.
              </p>
              <p style={{ margin: "0 0 12px" }}>In most cases, only the Cash Count amount is used.</p>
              <p style={{ margin: "0 0 8px" }}>
                To fully enable Over / Short processing, the corresponding Over / Short account
                must also be configured in the:
              </p>
              <div style={{ fontWeight: 700 }}>Other</div>
              <p style={{ margin: "8px 0 0" }}>mapping section.</p>
            </div>

            <div style={{ padding: "16px 20px", borderTop: "1px solid #e2e8f0", display: "flex", justifyContent: "flex-end" }}>
              <Button size="small" fill="true" onClick={() => setOpen(false)}>
                Close
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OverShortInfo;
